import Card from '../../components/card/Card';
import PageHeader from '../../components/pageHeader/PageHeader';
import CardSteps from '../../components/cardSteps/CardSteps';
import ChildrenRegistration from '../../components/registrationChildren/RegistrationChildren';
import { useContext, useEffect, useState } from 'react';
import './registration.css';
import DonorDetailsRegistration from '../../components/registrationDonorDetails/RegistrationDonorDetails';
import { registrationContex } from '../../service/RegisrationContext';
import PaymentMethod from '../paymentMethod/PaymentMethod';
import RegistrationCompleted from '../registrationCompleted/RegistrationCompleted';
import { appContext } from '../../service/AppContext';
import useBackButton from '../../service/useBackButton';
import TabSelector from '../buttons/TabSelector';
import { useLocation } from 'react-router-dom';

export default function Registration() {

const [currentStep, setCurrentStep] = useState(0)
  const { summaryKids, planMode, selectPlanMode } = useContext(registrationContex)
  const { fetchOptions, error } = useContext(appContext)
  const location = useLocation()

  // Hide the standard/family tabs only when entering from the simulator (standard only).
  // The wizard "jump to family" entry defaults to family but keeps the tabs so the donor
  // can still switch to the standard plans.
  const lockPlanMode = !!location.state?.fromSimulator

  // Plan mode selector lives above the card (full page width) and only on the children step
  const planModeTabs = [
    { label: 'תוכנית רגילה', onClick: () => selectPlanMode('standard') },
    { label: 'תוכנית משפחתית', onClick: () => selectPlanMode('family') },
  ]

  // Handle Fetch Errors
  useEffect(() => {
    if (error && ['/unit-request', '/bank-info', '/credit-card-info', '/manual-approval','/existing-permission'].includes(fetchOptions?.route)) {
      setCurrentStep(prev => (prev > 0) ? prev - 1 : prev)
    }
  }, [fetchOptions?.route, error])

  useBackButton(() => {
    setCurrentStep(prev => {
      // Payment complete - trap the user on the success screen by re-pushing
      // a history entry on every back press (they can only leave via the home button).
      if (prev >= 3) {
        window.history.pushState(null, '')
        return prev
      }
      return (prev > 0) ? prev - 1 : prev
    })
  })

  let dymanicStep = <></>
  if (currentStep === 0)
    dymanicStep = <ChildrenRegistration onCompleted={() => { setCurrentStep(1); window.history.pushState(null, '') }} />
  if (currentStep === 1)
    dymanicStep = <DonorDetailsRegistration onCompleted={() => { setCurrentStep(2); window.history.pushState(null, '') }} />
  if (currentStep === 2)
    dymanicStep = <PaymentMethod monthlyDonation={summaryKids?.totalMonthlyDonation} onCompleted={() => { setCurrentStep(3); window.history.pushState(null, '') }} />
  if (currentStep === 3)
    dymanicStep = <RegistrationCompleted />

  return (
    <div className='registration'>
      <PageHeader
        title='תהליך הצטרפות אונליין'
        description='מצטרפים עכשיו לגמ"ח המרכזי בתהליך דיגיטלי פשוט' />
      {(currentStep === 0 && !lockPlanMode) &&
        <div className="plan-mode-selector">
          <TabSelector tabs={planModeTabs} current={planMode === 'family' ? 1 : 0} />
        </div>
      }
      <Card>
        <CardSteps steps={['הילדים שלי', 'פרטי ההורה/התורם', 'אמצעי תשלום']} currentStep={currentStep} />
        {dymanicStep}
      </Card>
    </div>
  )
}
